import { render, staticRenderFns } from "./step4_detail.vue?vue&type=template&id=6756434a"
import script from "./step4_detail.vue?vue&type=script&lang=js"
export * from "./step4_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports